import checkObjectType from './_helpers/checkobjecttype.js';
import forEach from './_helpers/foreach.js';
import * as universalMethods from './matreshka/_universalmethods.js';
import Class from './class.js';
import apply from './_helpers/apply.js';
// create a prototype of ChainClass
// store target object at "object" property
var prototype = {
  constructor: function constructor(object) {
    this.object = object;
  }
};
var methodNames = Object.keys(universalMethods);
// iterate over all universal methods
var _loop = function _loop() {
  var methodName = methodNames[i];
  // biome-ignore lint/performance/noDynamicNamespaceImportAccess: every universal method gets a chained twin
  var method = universalMethods[methodName];
  // create every chained method
  prototype[methodName] = function chainedMethod() {
    var args = [this.object];
    forEach(arguments, function (argument) {
      args.push(argument);
    });
    apply(method, undefined, args);
    // returning this is important for chained calls
    return this;
  };
};
for (var i = 0; i < methodNames.length; i++) {
  _loop();
}
var ChainClass = Class(prototype);
// the function allows to chain static function calls on any object
export default function chain(object) {
  // check for type and throw an error if it is not an object and is not a function
  checkObjectType(object, 'chain');
  return new ChainClass(object);
}